<template>
    <l-marker 
        v-if="value != undefined"
        :lat-lng="[value.position.lat, value.position.lng]"
        :zIndexOffset="1500"
    >
        <l-icon 
            :icon-url="require('../assets/map/school.svg')" 
            :icon-size="[40, 40]" />
        <l-popup>
            <b-button 
                variant="secondary" 
                @click="$router.push('/ueber')"
            >
                Über
                <img src="../assets/interface/mug.svg" 
                    class="mt-n2" height="21em" width="21em"
                    style="filter:invert(90%)" 
                />
            </b-button>
        </l-popup>
    </l-marker>
</template>

<script>
import { LMarker, LIcon, LPopup } from 'vue2-leaflet'
export default {
    name: "UebersichtMarkerSchool",
    components: {
        LMarker,
        LIcon,
        LPopup
    },
    props:{
        value: undefined
    }
}
</script>